import { Layout } from '../CarouselTS/types'
import { GridItemLayout } from '../Grid/types'

export const getCardLayout = (gridLayout: GridItemLayout): Layout => {
  const cardLayout = {
    cardWidth: gridLayout.width,
    cardHeight: gridLayout.height,
    cardMarginRight: gridLayout.marginRight,
    carouselMarginBottom: gridLayout.marginBottom,
    screenVisibleItems: 0,
  } as Layout
  return cardLayout
}
